<div [className]="wrapperClasses">
  <div class="contain-width">
    <digital-platform-dynamic-content-wrapper
      *ngFor="let content of nestedFlexboxContent"
      [config]="content"
    ></digital-platform-dynamic-content-wrapper>
  </div>
</div>
